module.exports = __webpack_public_path__ + "img/ascend_gold5.b9175c1d.png";